// import React from 'react';
// import {
//   Box,
//   FormControl,
//   FormControlLabel,
//   Radio,
//   RadioGroup as MuiRadioGroup,
//   Typography,
// } from '@mui/material';
// import useStyles from './styles';

// export default function RatingRadio(props) {
//   const {
//     name,
//     value,
//     onChange,
//     items,
//     ratingStyle,
//     optionsFontStyle,
//     optionsFontSize,
//     errorMessage,
//     ...other
//   } = props;

//   const classes = useStyles(props);
//   console.log('items>>>>', items);

//   const typographyStyle = {
//     color: '#333',
//     fontFamily: optionsFontStyle ? `${optionsFontStyle} !important` : 'Poppins',
//     fontSize: optionsFontSize ? `${optionsFontSize}px !important` : '1rem',
//   };

//   const renderRadioGroup = () => (
//     <MuiRadioGroup
//       name={name}
//       value={value}
//       className={classes.root}
//       onChange={onChange}
//       {...other}
//     >
//       {items.map((item, index) => (
//         <FormControlLabel
//           key={index}
//           value={item.id}
//           control={<Radio className={classes.radio} disableRipple />}
//           label={
//             <Typography variant="body3" sx={typographyStyle}>
//               {item.title}
//             </Typography>
//           }
//           labelPlacement={'bottom'}
//         />
//       ))}
//     </MuiRadioGroup>
//   );

//   if (items.length === 0) return null;

//   return ratingStyle === 1 ? (
//     <FormControl sx={{ ml: 0, mr: 0 }} error={errorMessage ? true : false}>
//       {renderRadioGroup()}
//       {errorMessage && (
//         <Typography variant="body4" color="error">
//           {errorMessage}
//         </Typography>
//       )}
//     </FormControl>
//   ) : (
//     <Box sx={{ display: 'flex' }}>
//       <Typography
//         mt={1}
//         mr={1.5}
//         variant="body3"
//         sx={{
//           ...typographyStyle,
//           fontSize: optionsFontSize
//             ? `${optionsFontSize}px !important`
//             : '1rem',
//         }}
//       >
//         {items[0].title}
//       </Typography>
//       <FormControl sx={{ ml: 0, mr: 0 }}>{renderRadioGroup()}</FormControl>
//       <Typography
//         mt={1}
//         ml={1.5}
//         variant="body3"
//         sx={{
//           ...typographyStyle,
//           fontSize: optionsFontSize
//             ? `${optionsFontSize}px !important`
//             : '16px',
//         }}
//       >
//         {items[items.length - 1].title}
//       </Typography>
//     </Box>
//   );
// }

import React from 'react';
import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup as MuiRadioGroup,
  Typography,
  useMediaQuery,
} from '@mui/material';

// import useStyles from './styles';
import { useTheme } from '@mui/styles';

export default function RatingRadio(props) {
  const {
    name,
    label,
    value,
    onChange,
    items,
    labelPlacement,
    optionsFontStyle,
    ratingStyle,
    optionsFontSize,
    ...other
  } = props;

  // console.log('optionsFontStyle>>>>>', value);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  // const isMedium = useMediaQuery(theme.breakpoints.down('md')) && !isMobile;

  // const classes = useStyles(props);

  return items.length !== 0 ? (
    ratingStyle === 1 ? (
      <FormControl sx={{ ml: 0, mr: 0 }}>
        {/* <Typography variant="sh3" sx={{ color: "#333" }}>
        {label}
      </Typography> */}
        <MuiRadioGroup
          name={name}
          value={value}
          // className={classes.root}
          onChange={onChange}
          {...other}
        >
          {items.map((item, index) => (
            <FormControlLabel
              key={index}
              value={item.id}
              control={
                <Radio
                  // className={classes.radio}
                  disableRipple
                />
              }
              // label={item.title}
              label={
                <Typography
                  // variant="body3"
                  sx={{
                    color: '#333',
                    fontFamily: optionsFontStyle
                      ? `${optionsFontStyle} !important`
                      : 'Poppins',
                    // fontSize: optionsFontSize
                    //   ? `${optionsFontSize}px !important`
                    //   : '1rem',
                  }}
                >
                  {item.title}
                </Typography>
              }
              labelPlacement={'bottom'}
              sx={{
                margin: isMobile ? '1px' : '0px',
                '& .MuiFormControlLabel-label': {
                  margin: '0px',
                },
              }}
            />
          ))}
        </MuiRadioGroup>
      </FormControl>
    ) : (
      <Box sx={{ display: 'flex' }}>
        <FormControl sx={{ ml: 0, mr: 0 }}>
          <MuiRadioGroup
            name={name}
            value={value}
            // className={classes.root}
            onChange={onChange}
            {...other}
          >
            {items.map((item, index) => (
              <FormControlLabel
                key={index}
                value={item.id}
                control={<Radio disableRipple />}
                // labelPlacement={'bottom'}
                sx={{ mr: 3.5 }}
              />
            ))}
          </MuiRadioGroup>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography
              variant="body3"
              sx={{
                color: '#333',
                fontFamily: optionsFontStyle
                  ? `${optionsFontStyle} !important`
                  : 'Poppins',
                fontSize: optionsFontSize
                  ? `${optionsFontSize}px !important`
                  : '1rem',
                ml: items[0].title.length === 1 ? '6px' : '6px',
              }}
            >
              {items[0].title}
            </Typography>
            <Typography
              // mt={1}
              // ml={1.5}
              variant="body3"
              sx={{
                color: '#333',
                fontFamily: optionsFontStyle
                  ? `${optionsFontStyle} !important`
                  : 'Poppins',
                fontSize: optionsFontSize
                  ? `${optionsFontSize}px !important`
                  : '16px',
                mr:
                  items[items.length - 1].title.length === 1 ? '42px' : '40px',
              }}
            >
              {items[items.length - 1].title}
            </Typography>
          </Box>
        </FormControl>
      </Box>
    )
  ) : (
    <></>
  );
}
